import { List } from "immutable";

import { PropertyFormatIdentifier } from "../../constants/propertyFormats";
import syncLocalFields from "../../constants/syncLocalFields";
import { immutableRecords } from "../../types";
import { swatchColorToScrivenerColor } from "../../utils/colorUtils";

export default (orderedColors, propertiesById, id, fieldIdsMap) => {
  let optionsList = null;
  if (id === syncLocalFields.color) {
    optionsList = orderedColors;
  } else {
    const prop = propertiesById.get(id);
    if (prop && prop.format === PropertyFormatIdentifier.list && prop.allowed) {
      optionsList = prop.allowed;
    }
  }

  if (!optionsList) {
    return null;
  }

  let result = [];

  optionsList.forEach(o => {
    const localId = o.id;
    const externalId = fieldIdsMap && fieldIdsMap.has(localId) ? fieldIdsMap.get(localId) : localId;
    result.push(
      immutableRecords.SyncCustomFieldOptionRecord({
        id: externalId,
        label: o.label,
        color: o.swatchColor ? swatchColorToScrivenerColor(o.swatchColor) : null
      })
    );
  });

  return List(result);
};
